import { RoomCategory } from "@app/shared/enum/care-conne.enum";
import { SlideUpWindowByStudentState } from "./slide-up-window-by-student.state";
import { Store } from "@ngxs/store";
import { SettingSelectors } from "@app/store/setting/setting.selectors";
import { ROOM_CONDITIONS } from "./slide-up-window-by-student.utils";

export function filterByRoom(state: SlideUpWindowByStudentState, store: Store) {
    const filterCondtions = state.filters.filter(x => x.isActive);
    const activeFilters = filterCondtions
        .filter(f => f.isActive)
        .map(f => f.name);
    const carePass = store.selectSnapshot(SettingSelectors.CareConnePass);
    state.filteredRoomData = state.allRoomData.filter(room =>
        activeFilters.some((key) => ROOM_CONDITIONS[key]?.(room, carePass))
    );
}

export function filterToggle(state: SlideUpWindowByStudentState, value: { name: string, isActive: boolean }, store: Store) {
    if (value.name === RoomCategory.YOURCHAT) return;
    value.isActive = !value.isActive;
    filterByRoom(state, store);
}